import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import JustificatifTypeCreation from "../../../components/Admin/JustificatifTypes/JustificatifTypeCreation";
import styles from "../Admin.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faSquareCheck, faXmark} from "@fortawesome/free-solid-svg-icons";
import {getUtilisateurRoleIcon, getUtilisateurRoleLabel} from "../../../services/UserService";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";

function AdminJustificatifTypePage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [justificatifType, setJustificatifType] = useState({});
    const {justificatifTypeId} = useParams();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    useEffect(() => {
        (async () => {
            try {
                const response = await AxiosConfig.get(`/admin/justificatifs/types/${justificatifTypeId}`);
                setMyApiData(response.data.myJustificatifType);
                setJustificatifType(response.data.myJustificatifType);
            } catch (error) {
                console.error('error', error);
            }
        })();
    }, [user]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ justificatifType }));
    }, [justificatifType]);

    const fetchPost = async (url, data) => {
        try {
            const response = await AxiosConfig.post(url, data);
            setMyApiData(response.data.myJustificatifType);
            handleSuccess("Enregistré");
        } catch (error) {
            console.error('error', error);
            handleError("Erreur : "+error);
        }
    }
    const putActifOpenModal = () => {
        showModal('confirm', {
            message: "Voulez-vous vraiment supprimer ce justificatif ?",
            onConfirm: () => {
                fetchPost(`/admin/justificatifs/types/${myApiData.justId}/actif`, {actif: !myApiData.justActif});
            }
        });
    }


    return (
        <div className="content">
            <TitleMain text={myApiData.justLabel}/>

            {mode === 'creation' ?
                <JustificatifTypeCreation
                    justificatifType={justificatifType}
                /> :
                <div className={styles.viewBloc}>
                    <div className={styles.headerBtnsVue}>
                        <button onClick={putActifOpenModal}>{myApiData.justActif ? <><FontAwesomeIcon
                            icon={faXmark}/>Supprimer</> : <><FontAwesomeIcon
                            icon={faSquareCheck}/>Restaurer</>}</button>
                        <Link to={Routing.routes.adminCreation}><FontAwesomeIcon icon={faEdit}/>Modifier</Link>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <p className={styles.creerParLeBloc}>
                            Créé le {
                                DateService.formatDate(myApiData.date_created)
                            } et mis à jour le {
                                DateService.formatDate(myApiData.date_updated)
                            }
                        </p>

                        <span>Nom : {myApiData.justLabel}</span>
                        <span>Role concerné : {myApiData.justRole ? <>{getUtilisateurRoleIcon(myApiData.justRole)} {getUtilisateurRoleLabel(myApiData.justRole)}</> : "Tous les rôles"}</span>
                        <span>Obligatoire : {myApiData.justObligatoire ? "Obligatoire" : "Facultatif"}</span>
                    </div>
                </div>
            }
        </div>
    )
}

export default AdminJustificatifTypePage;
